import http, { handleHttpError, handleHttpResponse } from '../../shared/http'
import { HTTPResponse } from '../../shared/http/http.types'
import { IPaginationResponse } from '../../types/global'
import { IPlan, IPromo } from './promos.types'
import { IUser } from '../AuthProvider/user.api'

const getPromosList = (params: any): Promise<HTTPResponse<IPaginationResponse<IPromo[]>>> => {
  return http
    .get('/api/v1/admin/discounts/', { params: { ...(params || {}), ordering: '-created' } })
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const createPromo = (
  dto: Pick<IPromo, 'title' | 'description' | 'discount' | 'code' | 'plan' | 'expired'>
): Promise<HTTPResponse<IPromo>> => {
  return http.post('/api/v1/admin/discounts/', dto).then(handleHttpResponse).catch(handleHttpError)
}

const getPlans = (): Promise<HTTPResponse<IPlan[]>> => {
  return http.get('/api/v1/plans/').then(handleHttpResponse).catch(handleHttpError)
}

const getUsers = (params: any): Promise<HTTPResponse<IPaginationResponse<IUser[]>>> => {
  return http.get('/api/v1/admin/users/', { params }).then(handleHttpResponse).catch(handleHttpError)
}

const grantSubscription = (dto: { user: string; plan: string }): Promise<HTTPResponse<{}>> => {
  return http.post('/api/v1/admin/subscriptions/', dto).then(handleHttpResponse).catch(handleHttpError)
}

const promosApi = { getPromosList, createPromo, getPlans, getUsers, grantSubscription }
export default promosApi
